import React from "react";
import { ExternalLink } from "lucide-react";
import { useReveal } from "../hooks/useReveal";

const projects = [
  {
    name: "Develuk Investment",
    category: "Inwestycje · Strona rozbudowana",
    url: "https://develuk-investment.pl",
    image:
      "https://customer-assets.emergentagent.com/job_premium-web-build-13/artifacts/x6q7v5zs_develuk%20investment.png",
  },
  {
    name: "Kwit Kosmetologia",
    category: "Gabinet kosmetologii · SEO + Blog",
    url: "https://kwitkosmetologia.com",
    image:
      "https://customer-assets.emergentagent.com/job_premium-web-build-13/artifacts/md4vbk2y_kwit%20kosmetologia.png",
  },
  {
    name: "Pueblo Preludium",
    category: "Album · One-page z preorderem",
    url: "https://puebloptkwo.pl",
    image:
      "https://customer-assets.emergentagent.com/job_premium-web-build-13/artifacts/s106oboj_pueblo%20ptkwo.png",
  },
  {
    name: "Time Słupsk",
    category: "Manualna Terapia Twarzy i Kosmetologia",
    url: "https://time.slupsk.pl",
    image:
      "https://customer-assets.emergentagent.com/job_premium-web-build-13/artifacts/vvymmeq3_time%20-%20slupsk.png",
  },
  {
    name: "Trycholog Szczecinek",
    category: "Trychologia · Strona ekspercka",
    url: "https://trychologszczecinek.pl",
    image:
      "https://customer-assets.emergentagent.com/job_premium-web-build-13/artifacts/xzolvh6w_trycholog%20szczecinek.png",
  },
  {
    name: "Salon Ewa Beauty & Wellness",
    category: "Kosmetologia · Piercing · Makijaż",
    url: "https://salon-ewa.com",
    image:
      "https://customer-assets.emergentagent.com/job_premium-web-build-13/artifacts/n1e5u10t_salon%20ewa%20beauty%20and%20wellness.png",
  },
];

export const Portfolio = () => {
  const ref = useReveal();
  return (
    <section
      id="portfolio"
      ref={ref}
      data-testid="portfolio-section"
      className="relative py-24 md:py-32 px-6 md:px-10"
    >
      <div className="max-w-7xl mx-auto">
        <div className="reveal flex flex-col md:flex-row md:items-end md:justify-between gap-8 mb-14">
          <div>
            <span className="text-xs tracking-[0.2em] uppercase text-stormly-cyan font-bold">
              Realizacje
            </span>
            <h2 className="font-heading font-bold text-4xl sm:text-5xl md:text-6xl mt-4 leading-[1.05] max-w-2xl">
              Strony, które{" "}
              <span className="text-stormly-cyan">już pracują</span> dla naszych
              klientów.
            </h2>
          </div>
          <p className="md:max-w-sm text-white/60 text-base">
            Każdy projekt zaprojektowany od zera. Kliknij, by zobaczyć stronę na
            żywo.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 lg:gap-8">
          {projects.map((p, i) => (
            <a
              key={p.name}
              href={p.url}
              target="_blank"
              rel="noopener noreferrer"
              data-testid={`portfolio-card-${i}`}
              className={`tilt-card reveal reveal-delay-${(i % 4) + 1} group block bg-[#1F1F38] border border-white/10 rounded-3xl overflow-hidden hover:border-stormly-cyan/40 transition-all duration-500 ${
                i === projects.length - 1 && projects.length % 2 === 1
                  ? "md:col-span-2"
                  : ""
              }`}
            >
              <div className="relative aspect-[16/10] overflow-hidden bg-[#15152b]">
                <div className="tilt absolute inset-0 p-6 md:p-10">
                  <div className="relative h-full w-full rounded-xl overflow-hidden shadow-[0_30px_80px_rgba(0,0,0,0.5)] bg-[#0a0a1e] border border-white/10">
                    <div className="absolute top-0 left-0 right-0 h-7 bg-[#15152b] border-b border-white/10 flex items-center px-3 gap-1.5 z-10">
                      <span className="h-2 w-2 rounded-full bg-red-400/50" />
                      <span className="h-2 w-2 rounded-full bg-yellow-400/50" />
                      <span className="h-2 w-2 rounded-full bg-green-400/50" />
                      <span className="ml-3 text-[10px] text-white/40 font-mono truncate">
                        {p.url.replace("https://", "")}
                      </span>
                    </div>
                    <img
                      src={p.image}
                      alt={p.name}
                      loading="lazy"
                      className="absolute inset-0 top-7 w-full h-[calc(100%-1.75rem)] object-cover object-top group-hover:scale-[1.04] transition-transform duration-[1200ms] ease-out"
                    />
                  </div>
                </div>

                <div className="absolute inset-0 bg-gradient-to-t from-[#1A1A2E] via-transparent to-transparent opacity-60 group-hover:opacity-30 transition-opacity duration-500 pointer-events-none" />
              </div>

              <div className="p-6 md:p-8 flex items-center justify-between gap-4 border-t border-white/5">
                <div>
                  <p className="text-xs tracking-[0.18em] uppercase text-stormly-cyan/80 font-bold">
                    {p.category}
                  </p>
                  <h3 className="font-heading text-xl md:text-2xl font-bold mt-2">
                    {p.name}
                  </h3>
                </div>
                <span className="inline-flex items-center gap-2 text-sm text-white/70 group-hover:text-stormly-cyan transition-colors shrink-0">
                  <span className="hidden sm:inline">Zobacz live</span>
                  <ExternalLink size={16} />
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
};
